import axios from "axios";

interface IDownloadTourOperatorLogParams {
    id: string
}

interface IDownloadTourOperatorLogReturn {
    file: File,
    fileName: string
}

export const downloadTourOperatorLog = async ({
    id
}: IDownloadTourOperatorLogParams): Promise<IDownloadTourOperatorLogReturn> => {
    const response = await axios.get(
        `/booking/import/log/${id}`,
        {
            responseType: 'blob'
        }
    );
    const contentDisposition = response.headers['content-disposition'];
    const fileName = contentDisposition.match(/filename="(.*)"/)?.[1] ?? 'unknown';
    return {
        file: response.data,
        fileName
    };
};

export default downloadTourOperatorLog;